import React from 'react'

import styles from './Separator.module.scss'

interface ISeparator {
  hideLast?: boolean
}
const Separator = ({ hideLast }: ISeparator) => (
  <div className={hideLast ? styles.separatorHideLast : styles.separator} />
)

export default Separator
